import { useEffect, useState } from "react";

// โหมดการแสดงหมวดเมนูในแถบข้าง เลือกได้จากปุ่มเฟือง (ตั้งค่า) บน Header
//   priority (ค่าเริ่มต้น) — ยุบไว้ กางเฉพาะหมวดสำคัญกับหมวดของหน้าที่กำลังเปิดอยู่
//   all                    — กางทุกหมวดเหมือนก่อนหน้านี้
export const SIDEBAR_MENU_MODE_KEY = "sidebar-menu-mode";
export const SIDEBAR_GROUP_STATE_KEY = "sidebar-nav-groups";
export const MENU_MODE_PRIORITY = "priority";
export const MENU_MODE_ALL = "all";

const MENU_MODE_EVENT = "sidebar-menu-mode-change";

export const getMenuMode = () => {
  try {
    return localStorage.getItem(SIDEBAR_MENU_MODE_KEY) === MENU_MODE_ALL
      ? MENU_MODE_ALL
      : MENU_MODE_PRIORITY;
  } catch (err) {
    return MENU_MODE_PRIORITY;
  }
};

// เปลี่ยนโหมดแล้วล้างสถานะรายหมวดทิ้งด้วย ไม่งั้นหมวดที่ผู้ใช้เคยกดค้างไว้
// จะสวนกับโหมดที่เพิ่งเลือก (กด "กางทั้งหมด" แล้วบางหมวดยังยุบอยู่)
export const setMenuMode = (mode) => {
  const next = mode === MENU_MODE_ALL ? MENU_MODE_ALL : MENU_MODE_PRIORITY;
  try {
    localStorage.setItem(SIDEBAR_MENU_MODE_KEY, next);
    localStorage.removeItem(SIDEBAR_GROUP_STATE_KEY);
  } catch (err) {
    // เขียนไม่ได้ (โหมดส่วนตัว/ปิดที่เก็บข้อมูลเว็บ) ก็ยังสลับโหมดในรอบนี้ได้
  }
  window.dispatchEvent(new CustomEvent(MENU_MODE_EVENT, { detail: next }));
  return next;
};

export const readGroupState = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(SIDEBAR_GROUP_STATE_KEY));
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (err) {
    return {};
  }
};

export const writeGroupState = (id, open) => {
  try {
    const state = readGroupState();
    state[id] = open;
    localStorage.setItem(SIDEBAR_GROUP_STATE_KEY, JSON.stringify(state));
  } catch (err) {
    // เขียนไม่ได้ก็แค่ไม่จำข้ามรอบ
  }
};

// Header เป็นคนสั่งเปลี่ยน แต่ Sidebar เป็นคนแสดงผล — คนละต้นไม้กัน
// จึงส่งข่าวผ่าน window event (และ storage event เผื่อผู้ใช้เปิดหลายแท็บ)
export function useMenuMode() {
  const [mode, setMode] = useState(getMenuMode);

  useEffect(() => {
    const sync = () => setMode(getMenuMode());
    window.addEventListener(MENU_MODE_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(MENU_MODE_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return mode;
}
